export * from './Form';
export * from './FormLayout';
export * from './FormRow';
export * from './FormFooter';

import {Form} from './Form';
import {FormFooter as Footer} from './FormFooter';
import {FormLayout as Layout} from './FormLayout';
import {FormRow as Row} from './FormRow';

export default {Form, Layout, Row, Footer};
